import React from 'react';

class Aside extends React.Component {
    render() {
        return (
            <div>
                <h1>Aside</h1>
            </div>
        );
    }
}

export default Aside;
